import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Card, CardContent, Typography, Button, Box, IconButton, Grid } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";


const MembershipIDCard = () => {
    const [formData, setFormData] = useState(null);
    const cardRef = useRef(null);
    const isDataIncomplete = formData && Object.values(formData).some(value => value === "" || value === null);
    const isPaymentPending = formData?.Payment_Status
    === "Unpaid";
    const navigate = useNavigate();



    useEffect(() => {
        const mobile = localStorage.getItem("mobile");
        if (!mobile) {
            console.error("Mobile number not found in localStorage");
            return;
        }
        axios
            .get(`https://script.google.com/macros/s/AKfycbxzqU-4st_UykVlVN6--ea6tw7cDXSq5AGB83uScPQRz7b-hE4v_jopI4n7kpul9j_U/exec?action=myprofile&mobile=${mobile}`)
            .then((response) => {
                if (response.data.status === "success") {
                    setFormData(response.data.data);
                    console.log(response.data.data);
                } else {
                    console.error("API error:", response.data.message);
                }
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);


    const handleDownload = () => {
        const element = cardRef.current;
        html2pdf().from(element).save("Members_ID_Card.pdf");
    };
    


    console.log(formData);


    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            bgcolor="#f4f4f4"
            p={{ xs: 2, sm: 3 }}
        >
            <Typography variant="h6" gutterBottom color="#E52029" textAlign="center">
                Membership ID Card
            </Typography>


            {!formData ? (
                <Typography variant="body1" color="gray">
                    Loading...
                </Typography>
            ) : isDataIncomplete ? (
                    <Typography variant="body1" color="red" textAlign="center">
                    Your profile details are incomplete. Please update them to generate your ID card.{" "}
                    <Typography
                        component="span"
                        sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                        onClick={() => navigate("/profile")}
                    >
                        Click here
                    </Typography>{" "}
                    to navigate to your user profile.
                </Typography>
            ) : isPaymentPending ? (
                <Typography variant="body1" color="red" textAlign="center">
               Your payment is pending. Please complete the payment to generate your ID card.{" "}
                <Typography
                    component="span"
                    sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                    onClick={() => navigate("/whatsnext")}
                >
                   Click here
                </Typography>{" "}
                to proceed with the payment.
            </Typography>
            ) :(
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width={{ xs: "90%", sm: "80%", md: 600 }}
                    p={2}
                    border="2px solid #FAD707"
                    borderRadius={2}
                    bgcolor="#ffffff"
                    boxShadow={3}
                >
                    <IconButton onClick={handleDownload} color="black">
                        <DownloadIcon />
                        <Typography variant="body2" ml={1} color="black">
                            Download PDF
                        </Typography>
                    </IconButton>


                    <Card ref={cardRef} sx={{ width: "100%", p: 2, boxShadow: 3 }}>
                        <CardContent
                            sx={{
                                backgroundImage: "linear-gradient(to bottom, #FFD700, #FF4500)",
                                borderRadius: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <img src="/CWA_logo.png" alt="Logo" width={60} height={60} />
                                </Grid>
                                <Grid item>
                                    <Typography variant="h6" color="red" fontWeight="bold" textAlign="center">
                                        திருக்கடையூர் சேனைத்தலைவர் அறக்கட்டளை
                                    </Typography>
                                </Grid>
                            </Grid>


                            {/* White Box Section */}
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: 550,
                                    mt: 3,
                                    p: 2,
                                    background: "#f8f9e9",
                                    borderRadius: 2,
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 2,
                                }}
                            >
                                <Box textAlign="left">
                                    <Typography variant="body1">
                                        <strong>NAME:</strong> {formData.First_Name} {formData.Last_Name}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>MEMBER ID:</strong> {formData.Member_ID}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>DISTRICT:</strong> {formData.District}
                                    </Typography>
                                    <Typography variant="body1">
                                        <strong>LOCATION:</strong> {formData.City}
                                    </Typography>
                                </Box>


                                <QRCodeCanvas
                                    value={`TKS Member ID: ${formData.Member_ID}\nName: ${formData.First_Name} ${formData.Last_Name}\nDistrict: ${formData.District}\nLocation: ${formData.City}\nMobile Number: ${formData.Mobile_Number}`}
                                    size={100} // Adjusted for responsiveness
                                    bgColor="transparent"
                                    fgColor="#000000"
                                    level="L"
                                    marginSize={-9}
                                    imageSettings={{
                                        src: "/CWA_logo.png",
                                        height: 20,
                                        width: 20,
                                        opacity: 1.1,
                                        excavate: true,
                                    }}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            )}


            <Box mt={3}>
                <Button variant="contained" color="error" href="/">
                    Back to Homepage
                </Button>
            </Box>
        </Box>
    );
};


export default MembershipIDCard;



